var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _circle3, _path8, _path9, _path0, _path1, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle4, _circle5, _rect1, _rect10, _path10, _path11, _rect11, _rect12, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageMetricNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.5312,
    y: 141.572,
    width: 244,
    height: 145,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113.531,
    y: 285.572,
    width: 98,
    height: 22,
    fill: "#192657"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0312 146.072H112.031C103.198 146.072 83.8312 156.772 77.0312 199.572C70.2313 242.372 124.865 272.739 153.031 282.572H51.0312V146.072Z",
    fill: "#F58120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5313 251.572C81.5313 230.09 90.0125 209.487 105.109 194.297C120.206 179.106 140.681 170.572 162.031 170.572C183.381 170.572 203.857 179.106 218.953 194.297C234.05 209.487 242.531 230.09 242.531 251.572",
    stroke: "#528FF5",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.03 157.572C186.828 157.572 210.61 167.371 228.145 184.812",
    stroke: "#F58120",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5313 251.072L74.5312 251.072C74.5312 227.866 83.75 205.61 100.159 189.2C116.569 172.791 138.825 163.572 162.031 163.572C185.238 163.572 207.494 172.791 223.903 189.2C240.313 205.61 249.531 227.866 249.531 251.072L240.531 251.072",
    stroke: "#192657",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5312 251.072C82.5312 229.988 90.9071 209.766 105.816 194.857C120.725 179.948 140.947 171.572 162.031 171.572C183.116 171.572 203.337 179.948 218.246 194.857C233.155 209.766 241.531 229.988 241.531 251.072",
    stroke: "#192657",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.51 179.74C249.732 199.057 260.531 225.255 260.531 252.572",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.531,
    cy: 247.572,
    r: 12.5,
    fill: "white",
    stroke: "#192657"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.531,
    cy: 247.572,
    r: 9,
    fill: "#192657"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.031 177.572L156.531 247.072H169.031L162.031 177.572Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.531,
    cy: 247.572,
    r: 6,
    fill: "#F58120"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0312 206.072L93.5312 211.072",
    stroke: "#192657",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.531 206.072L231.031 211.072",
    stroke: "#192657",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M199.914 171.569L195.651 178.575",
    stroke: "#192657",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M125.652 171.569L129.916 178.575",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5312,
    y: 103.572,
    width: 19,
    height: 54,
    fill: "#528FF5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5312,
    y: 108.572,
    width: 17,
    height: 52,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5312,
    y: 84.5723,
    width: 19,
    height: 71.6897,
    fill: "#528FF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5312,
    y: 90.8828,
    width: 17,
    height: 69.6897,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 103.531,
    y: 71.5723,
    width: 19,
    height: 83.7931,
    fill: "#528FF5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5312,
    y: 78.7793,
    width: 17,
    height: 81.7931,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 133.531,
    y: 60.5723,
    width: 19,
    height: 94.0345,
    fill: "#528FF5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 129.531,
    y: 68.5376,
    width: 17,
    height: 92.0345,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.031,
    cy: 307.072,
    r: 15.5,
    stroke: "#F58120",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.531,
    cy: 307.572,
    r: 9,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 311.531,
    y: 181.572,
    width: 16,
    height: 82,
    fill: "#F58120"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 308.531,
    y: 182.572,
    width: 14,
    height: 80,
    stroke: "#192657",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M319.531 169.572L330.79 183.072H308.273L319.531 169.572Z",
    fill: "#F58120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M303.96 182.572L315.531 170.046L327.103 182.572H303.96Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 308.531,
    y: 266.572,
    width: 14,
    height: 14,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 308.531,
    y: 286.572,
    width: 14,
    height: 14,
    stroke: "#192657",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.532 258.072C110.199 296.406 7.73243 338.072 16.5324 198.072C27.5324 23.0724 239.531 13.5724 293.531 96.5724C347.531 179.572 356.53 309.572 259.531 275.572",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageMetricNew);
export default __webpack_public_path__ + "static/media/LandingPageMetricNew.e6f8358d90a154bdcd7034dcc1f620fc.svg";
export { ForwardRef as ReactComponent };